<template>
    <div class="message-item__content--audio-translation">
        <div class="content-wrap">
            <p class="text" :style="{background: color}">{{content}}</p>
            <div class="translation-tips">
                <div class="translation-tips__icon">
                    <svg width="12" height="12" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                        <g fill-rule="nonzero" fill="none">
                            <circle class="translation-tips__icon-bg" cx="7" cy="7" r="7"/>
                            <path stroke="#FFF" stroke-linecap="round" d="M3 6.223l2.745 3.102L11.366 4"/>
                        </g>
                    </svg>
                </div>
                <span class="translation-tips__text">转换完成</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MessageContentAudioTranslation',
        props: {
            content: {
                type: String,
                required: true,
                validator (value) {
                    return value.trim() !== ''
                }
            }
        },
        computed: {
            theme () {
                return this.$eventBus.theme
            },
            color () {
                if (this.theme === 'white') {
                    return this.$store.state.theme.color
                }
                return this.$store.state.lingkeColor
            }
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrap {
        padding: 10px 15px 10px 15px;
        @include radius(1);
    }

    .text {
        display: inline-block;
        font-size: 14px;
        line-height: 24px;
        word-break: break-all;
        word-wrap: break-word;
        vertical-align: top;
    }

    .translation-tips {
        display: flex;
        align-items: center;
        margin-top: 6px;

        &__icon {
            width: 12px;
            height: 12px;

            svg {
                vertical-align: top;
            }
        }

        &__text {
            font-size: 12px;
            line-height: 1;
            margin-left: 5px;
        }
    }

    .message-item--user {
        .content-wrap {
            color: #fff;
            background-color: $primary-color;
            @include radius(.5, .25, .5, .5);

            .text {
                color: #fff;
            }

            .translation-tips {
                &__icon-bg {
                    fill: #91C0FF;
                }

                &__text {
                    color: #BBD8FF;
                }
            }

            &:active {
                background-color: $primary-color-darken-bg;
            }
        }
    }

    .message-item--service {
        .content-wrap {
            background-color: #ffffff;
            @include radius(.25, .5, .5, .5);

            .text {
                color: $primary-text-color;
            }

            .translation-tips {
                &__icon-bg {
                    fill: #C5C5C5;
                }

                &__text {
                    color: #A8A8A8;
                }
            }
            .translation-tips__icon-bg {
                fill: #C5C5C5;
            }

            &:active {
                background-color: darken(#ffffff, 7%);
            }
        }
    }
</style>
